/** @prettier */

/**
 * A thin wrapper around localStorage that handles JSON serialization, key prefixing, and allows the
 * intended type for this particular store to be specified as a type param.
 *
 * Notes: assumes T is JSON-serializable
 **/
export default class PersistentStore<T> {
    constructor(
        private prefix = "",
        /** Optional validator function: if omitted, input is assumed to be valid */
        private validator = (x: any): x is T => true,
    ) {}

    private prefixedKey(key: string) {
        return `${this.prefix}-${key}`;
    }

    set(key: string, value: T): void {
        localStorage.setItem(this.prefixedKey(key), JSON.stringify(value));
    }

    get(key: string): T | null {
        const data = localStorage.getItem(this.prefixedKey(key));
        try {
            let rawData = data && JSON.parse(data);
            if (rawData && this.validator(rawData)) {
                return rawData;
            }
        } catch {
            /* if fails to parse, ignore */
        }
        return null;
    }
}
